import * as React from 'react';
import api from 'core/api';
import { Input } from '@teamsnap/snap-ui';

export default function useApiGetNgbIntegrations(
  seasonId: number | null
): [{ ngbIntegrations: NgbIntegration[] } | null, boolean, Error | null] {
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState<Error | null>(null);
  const [response, setResponse] = React.useState<{
    ngbIntegrations: NgbIntegration[];
  } | null>(null);

  const apiGet = async (
    seasonId: number | null
  ): Promise<{ ngbIntegrations: NgbIntegration[] } | undefined> => {
    setResponse(null);
    setIsLoading(false);
    if (!seasonId) return;
    try {
      setIsLoading(true);
      const response = await api.get<{ ngbIntegrations: NgbIntegration[] }>(
        `/seasons/${seasonId}/ngb_integrations`
      );
      setResponse(response.data ?? null);
      setIsLoading(false);
      return response.data;
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    apiGet(seasonId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seasonId]);

  return [response, isLoading, error];
}

export type NgbIntegration = {
  id: number;
  name: string;
  code: 'usa_lacrosse' | 'usa_hockey' | 'hockey_canada';
  metadata: {
    fields: any[];
    formRequirements: {
      name: string;
      title: string;
      subtitle: string;
      tooltipText: string;
      toggleLabel: string;
      fields: {
        name: NgbIntegrationFormFieldsNames;
        label: string;
        required: boolean;
        type: React.ComponentProps<typeof Input>['type'];
        adminHelpText: string;
        options: {
          seasonStartDate: string;
          seasonEndDate: string;
        }[];
      }[];
    };
    getMembershipLink: string;
    getMembershipText: string;
  };
};

type NgbIntegrationFormFieldsNames = 'enabled' | 'season_dates';
